import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronTriangleDownMedium"><Path d="M15.6405 9C16.9147 9.00022 17.6085 10.489 16.7889 11.4648L13.1483 15.7988C12.5489 16.5123 11.4508 16.5122 10.8514 15.7988L7.21076 11.4648C6.39103 10.489 7.08476 9.00009 8.3592 9H15.6405Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
